export const packageName = 'material';

export const enum Categories {
  Buttons = 'Buttons',
  Layout = 'Layout',
  FormControl = 'Form control',
  Text = 'Text',
  DataTable = 'Data table'
}
